import { roastEyebrow, type RoastTone } from '../lib/roasts'
import { openNavigatorHandoff } from '../lib/navigatorHandoff'

type Props = {
  text: string
  tone: RoastTone
  /** Show primary CTA when the roast is the drive-home nudge. */
  showNavigatorCta?: boolean
}

export function RoastCard({ text, tone, showNavigatorCta }: Props) {
  const showNav = showNavigatorCta ?? tone === 'navigator'

  return (
    <section className="roast-card">
      <p className="eyebrow text-ember">{roastEyebrow(tone)}</p>
      <p className="mt-2 text-lg font-semibold leading-snug text-foam">{text}</p>
      {showNav ? (
        <button
          type="button"
          className="secondary mt-4 min-h-11 text-sm"
          onClick={() => void openNavigatorHandoff('roast_card')}
        >
          Get home roasted →
        </button>
      ) : null}
    </section>
  )
}
